export default __webpack_public_path__ + "static/media/Postman.3ac4d784.png";